import controller from './most-selled-products.controller';
import templateBase from './templates/most-selled-products-base.view.html';

let MostSelledProductsComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {*/
    return templateBase;
    //}
}

export default MostSelledProductsComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/most-selled-products/most-selled-products.component.js
 **/